import '../../../global/manageCookieOnLoad.js'
import initComponents from '../../../global/components/index.js'
import initContactUs from '../../../global/_contact-us.js'
import initDropdown from '../../../global/_dropdown.js'
import initSiteUserTypeManager from '../../../global/_site-user-type-manager.js'
import initExternalLinks from '../../../global/_external-links.js'
import initNav from '../../../global/_nav.js'
import initStickyNav from '../../../global/_sticky-nav.js'
import initSwapLogo from '../../../global/_swap-home-logo'
import { init as initSecureLinkManager } from '../../../global/authentication/secure-link-manager.js'
import { init as initSynchStorage } from '../../..//global/data/synch-storage.js'
import { init as initProfile } from '../../../global/authentication/profile.js'
import { init as initLoginRedirectManager } from '../../../global/authentication/login-redirect-manager.js'
import { init as initIEModal } from '../../../components/Modal/IEModal.js'
import { init as initSessionTimeout } from '../../../global/authentication/session-timeout.js'
import '../css/index.css'

document.addEventListener(
  'DOMContentLoaded',
  () => {
    // harmless to non-promises, and will allow these to return
    // promises in the future
    Promise.all([
      initComponents(),
      initContactUs(),
      initDropdown(),
      initSiteUserTypeManager(),
      initExternalLinks(),
      initNav(),
      initStickyNav(),
      initSwapLogo(),
      // initSecureLinkManager(),
      initSynchStorage(),
      initProfile(),
      initLoginRedirectManager(),
      initIEModal(),
      initSessionTimeout(),
    ]).catch((e) => console.error(e))

    /* Put `initSecureLinkManager` here instead so it waits for SPA to render */
    setTimeout(() => {
      Promise.all([initSecureLinkManager()]).catch((e) => console.error(e))
    }, 1000)

    // analytics tags for march madness. remove code after campaign ends
    if (
      window.location.pathname.startsWith('/cti-site/cti-advisor/rebound') ||
      window.location.pathname.startsWith('/rebound')
    ) {
      const mensBracket = document.querySelectorAll(
        '[href="/binaries/content/assets/cti/public/fsa_529_mens_tournament_bracket.pdf"]'
      )
      const womensBracket = document.querySelectorAll(
        '[href="/binaries/content/assets/cti/public/fsa_529_womens_tournament_bracket.pdf"]'
      )

      if (mensBracket?.[0]) {
        mensBracket[0].dataset.analytics = 'cti-download-mens-bracket'
      }

      if (womensBracket?.[0]) {
        womensBracket[0].dataset.analytics = 'cti-download-womens-bracket'
      }
    }
  },
  false
)
